import React from 'react';
import { motion } from 'framer-motion';
export function StorySection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto text-center" data-id="element-242">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} data-id="element-243">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-244">
          Son las 3 de la madrugada.
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-blue-100 leading-relaxed" data-id="element-245">
          <p data-id="element-246">
            Tu bebé lleva llorando 40 minutos. Ya lo amamantaste. Ya lo
            cambiaste. Ya lo meciste.
          </p>
          <p data-id="element-247">Y ahí estás. De pie. En la oscuridad. Pensando:</p>
          <p className="text-2xl md:text-3xl font-semibold text-gold-400 py-4" data-id="element-248">
            ¿Qué estoy haciendo mal?
          </p>
          <p data-id="element-249">
            La respuesta honesta es:{' '}
            <span className="font-semibold text-white" data-id="element-250">
              probablemente nada.
            </span>
          </p>
          <p className="text-xl md:text-2xl font-medium text-white pt-4" data-id="element-251">
            El problema no sos vos. El problema es que nadie te dio un sistema.
          </p>
        </div>
      </motion.div>
    </section>;
}